import {createGlobalStyle} from 'styled-components';
import {rootElement} from './config';

const Transition = {
    BUTTON: 'var(--transition-button)',
    OVERLAY: 'var(--transition-overlay)',
};

const GlobalTransitions = createGlobalStyle`
    ${rootElement} {
        --transition-button: 0.2s;
        --transition-overlay: 0.15s;
    }
`;

export {Transition, GlobalTransitions};
